@font-face {
  font-family: 'Kohinoor';
  src: url('../public/fonts/KohinoorBangla/KohinoorBangla-Medium.otf');
}

.app {
  font-family: 'Montserrat', 'Open Sans', 'Lucidia Grande', 'Roboto', sans-serif;
}

*,
:before,
:after {
  box-sizing: border-box;
}

body {
  margin: 0;
  /* blush base so uncovered areas (e.g. the login route, where #main has no bg) aren't white */
  background-color: var(--main-bg-color);
}

input, button {
  line-height: inherit;
}

a {
  text-decoration: none;
}

a:hover {
  cursor: pointer;
}

:root {
  /* ── IncomeBazaar redesign system (brick red + ink navy + blush) ──
     New named tokens for redesigned components. Green is reserved for GAINS only. */
  --ib-red: #b91c1c;
  --ib-red-d: #9a1616;
  --ib-red-soft: #fbe6e5;
  --ib-navy: #1b2534;
  --ib-navy-2: #26313f;
  --ib-navy-line: #33404f;
  --ib-blush: #fbf1f0;
  --ib-panel: #ffffff;
  --ib-salmon: #eea9a9;
  --ib-salmon-tint: #f8dedd;
  --ib-good: #12855f;
  --ib-good-soft: #e5f2ec;
  --ib-amber: #c9800f;
  --ib-line: #f0dfde;
  --ib-line-2: #f9edec;
  --ib-chip: #f6ecec;
  --ib-ink: #1b2534;
  --ib-muted: #7d6f72;
  --ib-faint: #ab9a9d;
  /* Headings use a tight bold sans (a serif was rejected at large sizes). Token name kept
     for component references; numbers use the sans body font with tabular lining figures. */
  --font-serif: -apple-system, 'Segoe UI', 'Helvetica Neue', 'Montserrat', Roboto, Arial, sans-serif;
  --sans: 'Montserrat', -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;

  --promo-bg-color: #f6ecec;
  --main-bg-color: #fbf1f0;
  --sidebar-bg-color: #1b2534;
  --navbar-selected-button-text-color: #ffffff;
  --deposit-withdraw-bg-color: #ffffff;

  --navbar-bg-color: #ffffff;

  /* brand accent (formerly orange) → brick red; standard deal-card border + login */
  --green-primary-color: #b91c1c;
  --green-primary-bg-color: #b91c1c;
  --green-primary-hvr-color: #9a1616;

  /* secondary accent (debt deals) → ink navy to stay distinct from the red standard deals */
  --green-secondary-color: #1b2534;
  --green-secondary-bg-color: #26313f;
  --green-secondary-hvr-color: #1b2534;

  --grey-text-subtitle-color: #7d6f72;

  --button-bg-color: #b91c1c;
  --button-bg-hover-color: #9a1616;

  --button-border-color: #b91c1c;
  --button-border-hover-color: #9a1616;

  --disabled-button-bg-color: #f2e3e2;
  --disabled-button-text-color: #ab9a9d;
  --disabled-button-border-color: #f0dfde;
  --red-text-color: #b91c1c;

  --deal-border-color: #f0dfde;

  /* purchase alerts */
  --purchase-warning-color: #c9800f;
  --purchase-success-color: #12855f;
  --purchase-error-color: #b91c1c;
  --purchase-warning-bg-color: #fdf3e0;
  --purchase-success-bg-color: #e5f2ec;
  --purchase-error-bg-color: #fbe6e5;
  --purchase-default-text-color: #1b2534;

  /* login - styling */
  --login-text-color: #b91c1c;
  --login-border-color: #b91c1c;
  --login-bg-color: rgba(185, 28, 28, 0.92);
  --login-hvr-color: #9a1616;
  --about-texts-color: #ffffff;
  --white-color: #ffffff;
  --signin-btn-bg-color: #ffffff;

  /* Password Reset and Login Page Label Style  */
  --reset-password-label-color: #7d6f72;
  --login-error-message-color: #b91c1c;

  /* overview */
  --default-text-color: #1b2534;
  --default-text-secondary-color: #273746;
  --default-footer-attribute-color: #7d6f72;

  /* portfolio */
  --deal-portfolio-attributes-color: #ab9a9d;
  --deal-portfolio-attributes-INR-color: #12855f;
  --default-border-color: #cbb9b9;
  --portfolio-tab-color: #b91c1c;

  /* deal cards  */
  --deal-card-bg-color: #ffffff;
  --deal-attributes-color: #a89a9c;
  --deal-attributes-INR-color: #12855f;
  --deal-attributes-value-color: #1b2534;
  --selected-footer-attribbute-color: #b91c1c;

  /* profile  */
  --profile-active-text-color: #b91c1c;
  --profile-active-bg-color: #fbe6e5;
  --default-profile-text-color: #1b2534;

  --footer-bg-color: #f6ecec;

  /* Register Attributes */
  --register-attributes-message-success: #12855f;
  --register-attributes-message-failure: #b91c1c;
  --register-attributes-message-warning: #c9800f;
  --register-attributes-details: #7d6f72;
  --register-attributes-label: #566573;

  --scale-card: scale(1);

  --modal-close-icon-size: 1.35rem;

  /* font sizing */
  /* This must be in the last */
  --base-font-size: calc(9px + 0.390625vw);
  font-size: var(--base-font-size);
  scroll-behavior: smooth;
  line-height: 1.5715;
}
